import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import { queryParamsModule } from '@/modules/queryParams';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { useOnboarding } from '@/pages/Onboarding/context';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataKeyType, LayoutDataType } from '../../types';

import { INTERACTION_OPTIONS } from './constants';
import './Interaction.scss';

export const OnboardingReplikaInteraction: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Interaction',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const interaction = form.watch('interaction');

  const handleNextStep = (): void => {
    const interactionOption = INTERACTION_OPTIONS.find(
      (option) => option.id === interaction,
    );
    userService.createOrUpdate({
      onboarding_data: {
        interaction: interactionOption?.title || '',
      },
    });
    wizard.nextStep();
  };

  const handleBackStep = (): void => {
    wizard.goToStep('topics');
  };

  return (
    <OnboardingPage className="onboarding-interaction">
      <OnboardingNavigation onBack={handleBackStep} />

      <IonContent>
        <OnboardingTitle className="onboarding-interaction__title">
          What kind of interactions do you enjoy?
        </OnboardingTitle>
        <OnboardingOptionsList>
          {INTERACTION_OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={interaction === option.id}
              control={form.control}
              option={option}
              name="interaction"
              key={option.id}
              onChange={(value) => {
                queryParamsModule.setParam<LayoutDataKeyType>(
                  'interaction',
                  value,
                );
              }}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>

      <OnboardingFooter onContinue={handleNextStep} disabled={!interaction} />
    </OnboardingPage>
  );
};
